import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { defineMessages, injectIntl } from 'react-intl';
import BasicDataPod from '../../../components/BasicDataPod';
import Value from '../../../components/BasicDataPod/Value';
import Link from '../../../components/BasicDataPod/Link';
import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.overview.overlaps.title',
    defaultMessage: 'College Overlaps',
  },
  description: {
    id: 'hubs.overview.overlaps.description',
    defaultMessage: 'See other colleges that applicants to this school also applied to',
  },
});

function createOverlapUrl(data) {
  return `/colleges/overlaps/uuid/${get(data, 'college.collegeUUID', '')}`;
}

// The overlaps.colleges array has on index 0 the current college, so we need to substract 1 from length
function Overlaps({ overlaps, intl }) {
  const colleges = get(overlaps, 'colleges', []);
  const value = colleges.length - 1;
  const title = intl.formatMessage(messages.title);

  return value > 0 ? (
    <BasicDataPod header={title} ariaLabel={`${title}, ${value}`}>
      <div className="overlaps-data-pod-value-container">
        <Value value={value} />
      </div>
      <Link
        linkText={intl.formatMessage(messages.description)}
        linkUrl={createOverlapUrl(colleges[0])}
        external
      />
    </BasicDataPod>
  ) : null;
}

export default injectIntl(Overlaps);

Overlaps.propTypes = {
  lastUpdated: PropTypes.string,
  overlaps: PropTypes.object,
  intl: PropTypes.object,
};
